import { useEffect, useState } from "react";
import GraphemeSplitter from "grapheme-splitter";

export const useTypingPlaceholder = (
  phrases: string[],
  speed = 30,
  delay = 1500
) => {
  const [placeholder, setPlaceholder] = useState("");
  const [index, setIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  const splitter = new GraphemeSplitter();
  const currentPhrase = phrases[index];
  const graphemes = splitter.splitGraphemes(currentPhrase);

  useEffect(() => {
    const isTyping = charIndex < graphemes.length;

    const timeout = setTimeout(
      () => {
        if (isTyping) {
          setPlaceholder(graphemes.slice(0, charIndex + 1).join(""));
          setCharIndex((prev) => prev + 1);
        } else {
          setTimeout(() => {
            setPlaceholder("");
            setCharIndex(0);
            setIndex((prev) => (prev + 1) % phrases.length);
          }, delay);
        }
      },
      isTyping ? speed : 0
    );

    return () => clearTimeout(timeout);
  }, [charIndex, index, delay, graphemes, speed, phrases.length]);

  return placeholder;
};
